import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IRtpRespondentSettings } from '../../interfaces/configuration/rtp-respondent-settings.interface';
import { IRtpCorrespondentSettings } from '../../interfaces/configuration/rtp-correspondent-settings.interface';
import { IRtpStandaloneSettings } from '../../interfaces/configuration/rtp-standalone-settings.interface';

export abstract class AbstractRtpCorrespondentConfigurationService {
  abstract getRtpRespondentSettings(
    routingNumber: string
  ): Promise<IRtpRespondentSettings | undefined>;

  abstract updateRtpRespondentSettings(
    settings: IRtpRespondentSettings
  ): Promise<IWebMessage | undefined>;

  abstract getRtpCorrespondentSettings(
    routingNumber: string
  ): Promise<IRtpCorrespondentSettings | undefined>;

  abstract updateRtpCorrespondentSettings(
    settings: IRtpCorrespondentSettings
  ): Promise<IWebMessage | undefined>;

  abstract getRtpStandaloneSettings(
    routingNumber: string
  ): Promise<IRtpStandaloneSettings | undefined>;

  abstract updateRtpStandaloneSettings(
    settings: IRtpStandaloneSettings
  ): Promise<IWebMessage | undefined>;
}
